import { type ChargeBeePlan, ChargeBeePlanId } from '@prerender/billing-shared';

type Plan = {
  id: ChargeBeePlan['chargeBeePlanId'];
  name: ChargeBeePlan['name'];
  index: ChargeBeePlan['index'];
  costInCents: ChargeBeePlan['costInCents'];
  addonCostInCents: ChargeBeePlan['addonCostInCents']; // cost per 1000 extra renders
  suggested: ChargeBeePlan['suggested'];
  current: ChargeBeePlan['current'];
  includedCaches: number; // included renders
  cacheRefreshInterval: ChargeBeePlan['cacheRefreshInterval']; // days
  cacheLocation: ChargeBeePlan['cacheLocation'];
  available: ChargeBeePlan['available'];
  support: ChargeBeePlan['support'];
  contactUsToUse: ChargeBeePlan['contactUsToUse'];
  tier: ChargeBeePlan['tier'];
  apiAccess: ChargeBeePlan['apiAccess'];
  domainSchedulerSettingsMaxRules?: ChargeBeePlan['domainSchedulerSettingsMaxRules'];
  sitemapRevisitInterval?: ChargeBeePlan['sitemapRevisitInterval']; // hours ...
  dataRetentionDays?: ChargeBeePlan['dataRetentionDays'];
  dataRetentionDaysExport?: ChargeBeePlan['dataRetentionDaysExport'];
  auditLog?: ChargeBeePlan['auditLog'];
  dashboardAlerts?: ChargeBeePlan['dashboardAlerts'];
  searchPerformanceMaxDomains?: ChargeBeePlan['searchPerformanceMaxDomains'];
  legacy: ChargeBeePlan['legacy'];
};

export const PLANS_DESCRIPTIONS: Partial<Record<ChargeBeePlanId, string>> = {
  [ChargeBeePlanId.Starter]: 'For side projects',
  [ChargeBeePlanId.Growth]: 'For growing teams',
  [ChargeBeePlanId.Pro]: 'For high traffic',
  [ChargeBeePlanId.EnterprisePlus]: 'For global brands',
  [ChargeBeePlanId.CustomEnterprise3Years]: 'For global brands',
};

export default Plan;
